import './DnaHelix.css';

export const DnaHelix = ({ size = 'md' }) => {
  const sizeClass = size === 'sm' ? 'dna-sm' : 'dna-md';
  const rungs = 8;
  const duration = 2.5;

  return (
    <span className={`dna-helix-wrapper ${sizeClass}`} data-testid="dna-helix">
      {[...Array(rungs)].map((_, i) => {
        const delay = `${-(i * (duration / rungs)).toFixed(2)}s`;
        return (
          <span key={i} className="dna-rung-row">
            <span className="dna-orb dna-orb-red" style={{ animationDelay: delay }} />
            <span className="dna-link" style={{ animationDelay: delay }} />
            <span className="dna-orb dna-orb-white" style={{ animationDelay: delay }} />
          </span>
        );
      })}
    </span>
  );
};
